import React, { useState } from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { jsonForm, visibilityType } from '@europrocurement/flexy-form/utils/types/formTypes';
import { CustomOptionResolvers } from '@europrocurement/flexy-form';

// eslint-disable-next-line import/no-cycle
import JsonForm from '../../JsonForm';

export type GestionFermetureEtablissementModalProps = {
    onChange: (currentPage: number, pageLength: number, data?: Record<string, unknown>) => void;
    json: jsonForm;
    defaultValues: Record<string, unknown>;
    customOptionResolvers: CustomOptionResolvers;
    visibility?: visibilityType;
    showCancelFermeture?: boolean;
};

const GestionFermetureEtablissementModal: React.FunctionComponent<GestionFermetureEtablissementModalProps> =
    function ({
        onChange,
        json,
        defaultValues,
        customOptionResolvers,
        visibility,
        showCancelFermeture = false,
    }: GestionFermetureEtablissementModalProps) {
        const theme = useTheme();

        const [currentValues, setCurrentValues] = useState(defaultValues);
        const [formKey, setFormKey] = useState(0);

        const handleCancelFermeture = () => {
            const resetValues = {
                ...currentValues,
                personneMorale: {
                    ...((currentValues.personneMorale as Record<string, unknown>) ?? {}),
                    autresEtablissements: {
                        ...(((currentValues.personneMorale as Record<string, unknown>)
                            ?.autresEtablissements as Record<string, unknown>) ?? {}),
                        descriptionEtablissement: {
                            ...(((
                                (currentValues.personneMorale as Record<string, unknown>)
                                    ?.autresEtablissements as Record<string, unknown>
                            )?.descriptionEtablissement as Record<string, unknown>) ?? {}),
                            dateEffetFermeture: null,
                            destinationEtablissement: null,
                            autreDestination: null,
                        },
                        effectifSalarie: {
                            dateCessationEmploiSalaries: null,
                        },
                    },
                },
            };
            setCurrentValues(resetValues);
            setFormKey((k) => k + 1);
            // Enregistrement automatique avec les valeurs réinitialisées
            onChange(0, 1, resetValues);
        };

        return (
            <Box sx={{ width: '60%', margin: 'auto' }}>
                {showCancelFermeture && (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            marginBottom: '16px',
                            paddingTop: '16px',
                        }}
                    >
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={handleCancelFermeture}
                            sx={{
                                borderRadius: '10px',
                                padding: '10px 20px',
                                fontWeight: 'bold',
                                textTransform: 'none',
                            }}
                        >
                            Annuler le transfert de cet établissement
                        </Button>
                    </Box>
                )}
                <JsonForm
                    key={formKey}
                    onChange={onChange}
                    visibility={visibility || 'FULL'}
                    debugMode={false}
                    json={json as jsonForm}
                    startPage={0}
                    defaultValues={currentValues}
                    customOptionResolvers={customOptionResolvers}
                    submitLabel="Enregistrer les informations"
                    submitStyle={{
                        backgroundColor: theme.palette.primary.dark,
                        marginTop: '30px',
                        padding: '20px 25px',
                        fontSize: '1rem',
                        borderRadius: '15px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                />
            </Box>
        );
    };

export default GestionFermetureEtablissementModal;
